(function () {
  const selectors = document.querySelectorAll('[data-rmds-frame-selector]');
  if (!selectors.length) return;

  const productCache = new Map();

  function fetchProduct(handle) {
    if (!productCache.has(handle)) {
      const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = `${rootPath}products/${handle}.js`;
      productCache.set(handle, fetch(url, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error(`Frame product “${handle}” is not available.`);
        return response.json();
      }));
    }
    return productCache.get(handle);
  }

  function normalizedSize(title) {
    const match = String(title || '').toUpperCase().match(/\bA(?:0|1|2|3|4|5|6)\b/);
    return match ? match[0] : String(title || '').trim();
  }

  function formatMoney(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency
      }).format(Number(cents) / 100);
    } catch (_) {
      return `£${(Number(cents) / 100).toFixed(2)}`;
    }
  }

  function findMasterVariant(product, size, frame) {
    if (!product || !product.variants) return null;
    return product.variants.find((variant) => {
      const options = (variant.options || []).map((option) => String(option).toLowerCase());
      return options.includes(size.toLowerCase()) && options.includes(frame.toLowerCase());
    }) || product.variants.find((variant) => {
      const title = String(variant.title || '').toLowerCase();
      return title.includes(size.toLowerCase()) && title.includes(frame.toLowerCase());
    });
  }

  function findAddOnVariant(card, size) {
    // Prefer variants embedded by Liquid when available. For Unlisted/hidden
    // add-on products, Liquid can sometimes return a blank all_products drop in
    // theme previews, so we also support a client-side product fetch by handle.
    const nodes = Array.from(card.querySelectorAll('[data-rmds-addon-variant]'));
    const node = nodes.find((item) => normalizedSize(item.dataset.size) === size);
    if (node) {
      return {
        id: Number(node.dataset.id),
        price: Number(node.dataset.price),
        available: node.dataset.available === 'true'
      };
    }

    const product = card._rmdsAddonProduct;
    if (!product || !Array.isArray(product.variants)) return null;
    const variant = product.variants.find((item) => {
      const candidates = [item.title].concat(item.options || []);
      return candidates.some((value) => normalizedSize(value) === size);
    });
    if (!variant) return null;
    return {
      id: Number(variant.id),
      price: Number(variant.price),
      available: variant.available !== false
    };
  }

  async function loadAddOnProduct(card) {
    if (!card || card.dataset.master === 'unframed') return null;
    if (card.querySelector('[data-rmds-addon-variant]')) return true;

    const handles = [card.dataset.addonHandle, card.dataset.addonAltHandle].filter(Boolean);
    for (const handle of handles) {
      try {
        const product = await fetchProduct(handle);
        if (product && Array.isArray(product.variants) && product.variants.length) {
          card._rmdsAddonProduct = product;
          card.dataset.rmdsAddonLoaded = 'true';
          return product;
        }
      } catch (_) {}
    }
    card.dataset.rmdsAddonLoaded = 'false';
    return null;
  }

  function init(root) {
    const sizeSelect = root.querySelector('[data-rmds-size]');
    const sizePicker = root.querySelector('[data-rmds-size-picker]');
    const sizeCurrent = root.querySelector('[data-rmds-size-current]');
    const sizeCurrentPrice = root.querySelector('[data-rmds-size-current-price]');
    const sizeMenu = root.querySelector('[data-rmds-size-menu]');
    const nativeOption = root.querySelector('[data-rmds-native-option]');
    const extraOptionSelects = Array.from(root.querySelectorAll('[data-rmds-extra-option]'));
    const cards = Array.from(root.querySelectorAll('[data-rmds-frame]'));
    const error = root.querySelector('[data-rmds-error]');
    const fallbackAddButton = root.querySelector('[data-rmds-add]');
    const fallbackAddPrice = root.querySelector('[data-rmds-add-price]');
    const productContainer = root.closest('[data-section-id]') || root.closest('.product') || document;
    const form = productContainer.querySelector('form[data-product-form]');
    if (!sizeSelect || !form) return;

    let selectedCard = cards[0];
    let masterProducts = { oak: null, specialist: null };
    let sizeUnit = 'in';
    try { sizeUnit = localStorage.getItem('rmds-size-unit') || 'in'; } catch (_) {}

    function parseEmbeddedProduct(selector) {
      const node = root.parentElement.querySelector(selector);
      if (!node || !node.textContent.trim() || node.textContent.trim() === 'null') return null;
      try { return JSON.parse(node.textContent); } catch (_) { return null; }
    }

    masterProducts.oak = parseEmbeddedProduct('[data-rmds-oak-product]');
    masterProducts.specialist = parseEmbeddedProduct('[data-rmds-specialist-product]');

    // Some product-option apps rewrite native <option> labels. Keep this
    // selector independent and restore the explicit "Size — Price" labels.
    function restoreSizeLabels() {
      Array.from(sizeSelect.options).forEach((option) => {
        if (option.dataset.display) option.textContent = option.dataset.display;
      });
    }

    function optionMatchesArtworkChoices(option) {
      return extraOptionSelects.every((select) => {
        const position = Number(select.dataset.optionPosition || 0);
        return !position || option.getAttribute(`data-option-${position}`) === select.value;
      });
    }

    function availableSizeOptions() {
      return Array.from(sizeSelect.options).filter(optionMatchesArtworkChoices);
    }

    function selectMatchingSize(preferredSize) {
      const options = availableSizeOptions();
      const match = options.find((option) => normalizedSize(option.dataset.title) === preferredSize) || options[0];
      if (match) sizeSelect.value = match.value;
      return match;
    }

    function syncCustomSizePicker() {
      const selected = sizeSelect.options[sizeSelect.selectedIndex];
      if (sizeCurrent && selected) sizeCurrent.textContent = selected.dataset[`label${sizeUnit === 'cm' ? 'Cm' : 'In'}`] || selected.dataset.title;
      if (sizeCurrentPrice && selected) sizeCurrentPrice.textContent = formatMoney(selected.dataset.price);
      root.querySelectorAll('[data-rmds-unit]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.rmdsUnit === sizeUnit);
      });
      if (sizeMenu) {
        Array.from(sizeMenu.querySelectorAll('[data-rmds-size-value]')).forEach((button) => {
          button.setAttribute('aria-selected', button.dataset.rmdsSizeValue === sizeSelect.value ? 'true' : 'false');
        });
      }
    }

    function buildCustomSizePicker() {
      if (!sizeMenu) return;
      sizeMenu.textContent = '';
      availableSizeOptions().forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rmds-size-picker__option';
        button.dataset.rmdsSizeValue = option.value;
        const label = document.createElement('span');
        label.textContent = option.dataset[`label${sizeUnit === 'cm' ? 'Cm' : 'In'}`] || option.dataset.title;
        const price = document.createElement('span');
        price.className = 'rmds-size-picker__option-price';
        price.textContent = formatMoney(option.dataset.price);
        button.append(label, price);
        button.addEventListener('click', () => {
          sizeSelect.value = option.value;
          sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          if (sizePicker) sizePicker.open = false;
        });
        sizeMenu.appendChild(button);
      });
      syncCustomSizePicker();
    }

    root.querySelectorAll('[data-rmds-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        sizeUnit = button.dataset.rmdsUnit;
        try { localStorage.setItem('rmds-size-unit', sizeUnit); } catch (_) {}
        buildCustomSizePicker();
      });
    });

    const handles = {
      oak: root.dataset.oakHandle,
      specialist: root.dataset.specialistHandle
    };

    Promise.all([
      masterProducts.oak
        ? Promise.resolve()
        : fetchProduct(handles.oak).then((p) => { masterProducts.oak = p; }).catch((e) => e),
      root.dataset.country === 'GB' && !masterProducts.specialist
        ? fetchProduct(handles.specialist).then((p) => { masterProducts.specialist = p; }).catch((e) => e)
        : Promise.resolve(),
      ...cards.filter((card) => card.dataset.master !== 'unframed').map(loadAddOnProduct)
    ]).then(updateCards);

    function selectedSize() {
      return normalizedSize(sizeSelect.options[sizeSelect.selectedIndex].dataset.title);
    }

    function setNativeVariant() {
      const option = sizeSelect.options[sizeSelect.selectedIndex];
      // The Size option is not always option1 (some products are Colour → Size),
      // so use the actual size value rather than assuming Shopify option order.
      nativeOption.value = option.dataset.title;
      nativeOption.dispatchEvent(new Event('change', { bubbles: true }));
      const idInput = form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = option.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function switchToSelectedArtworkImage() {
      const option = sizeSelect.options[sizeSelect.selectedIndex];
      const mediaId = option && option.dataset.mediaId;
      if (!mediaId) return;

      // Use Cornerstone's own thumbnail handler so desktop, mobile, zoom and
      // the active thumbnail all remain synchronized with Shopify's variant image.
      const thumbnail = productContainer.querySelector(`.product__media-container.above-mobile [data-thumbnail-id="${mediaId}"]`)
        || productContainer.querySelector(`[data-thumbnail-id="${mediaId}"]`);
      if (thumbnail) thumbnail.click();
    }

    function artworkProperties() {
      return extraOptionSelects.reduce((properties, select) => {
        properties[`Artwork ${select.dataset.optionName || 'option'}`] = select.value;
        return properties;
      }, {});
    }


    function existingLineItemProperties() {
      const properties = {};
      try {
        const data = new FormData(form);
        data.forEach((value, key) => {
          const match = String(key).match(/^properties\[(.+)\]$/);
          if (!match || value instanceof File) return;
          properties[match[1]] = String(value);
        });
      } catch (_) {}
      return properties;
    }

    function selectedMasterVariant() {
      if (selectedCard.dataset.master === 'unframed') return null;
      const embedded = findEmbeddedVariant(selectedCard, selectedSize());
      if (embedded) return embedded;
      return findMasterVariant(masterProducts[selectedCard.dataset.master], selectedSize(), selectedCard.dataset.rmdsFrame);
    }


    function selectedFrameChoice() {
      if (selectedCard.dataset.master === 'unframed') return null;
      const size = selectedSize();
      const hasAddOnProduct = selectedCard.querySelector('[data-rmds-addon-variant]') !== null || selectedCard.dataset.rmdsAddonLoaded === 'true';
      const addOnVariant = findAddOnVariant(selectedCard, size);

      if (hasAddOnProduct) {
        return {
          mode: 'addon',
          variant: addOnVariant,
          totalPrice: addOnVariant
            ? Number(sizeSelect.options[sizeSelect.selectedIndex].dataset.price) + Number(addOnVariant.price)
            : null
        };
      }

      const legacyVariant = selectedMasterVariant();
      return {
        mode: 'legacy',
        variant: legacyVariant,
        totalPrice: legacyVariant ? Number(legacyVariant.price) : null
      };
    }

    function findEmbeddedVariant(card, size) {
      const node = Array.from(card.querySelectorAll('[data-rmds-master-variant]')).find((item) => normalizedSize(item.dataset.size) === size);
      if (!node) return null;
      return { id: Number(node.dataset.id), price: Number(node.dataset.price), available: true };
    }

    function updateDisplayedPrice(cents) {
      productContainer.querySelectorAll('[data-price]').forEach((node) => { node.textContent = formatMoney(cents); });
      productContainer.querySelectorAll('[data-compare-price]').forEach((node) => { node.textContent = ''; });
      if (fallbackAddPrice) fallbackAddPrice.textContent = formatMoney(cents);
    }

    function nativeAddButtonIsVisible() {
      const nativeButton = form.querySelector('[data-add-to-cart]');
      if (!nativeButton) return false;
      const style = window.getComputedStyle(nativeButton);
      return !nativeButton.disabled && style.display !== 'none' && style.visibility !== 'hidden' && nativeButton.getClientRects().length > 0;
    }

    function syncFallbackAddButton() {
      if (!fallbackAddButton) return;
      fallbackAddButton.hidden = nativeAddButtonIsVisible();
    }

    if (fallbackAddButton) {
      fallbackAddButton.addEventListener('click', () => {
        if (fallbackAddButton.disabled) return;
        const nativeButton = form.querySelector('[data-add-to-cart]');
        if (nativeButton && !nativeButton.disabled) nativeButton.click();
        else form.requestSubmit();
      });
    }

    function updateCards() {
      const size = selectedSize();
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      const isDigital = selectedOption.dataset.digital === 'true';
      cards.forEach((card) => {
        const priceNode = card.querySelector('[data-rmds-card-price]');
        if (card.dataset.master === 'unframed') {
          card.disabled = selectedOption.dataset.available !== 'true';
          priceNode.textContent = `${formatMoney(selectedOption.dataset.price)} total`;
          return;
        }
        if (isDigital) {
          card.disabled = true;
          priceNode.textContent = 'Not available for digital downloads';
          if (card === selectedCard) selectCard(cards[0]);
          return;
        }
        const hasAddOnProduct = card.querySelector('[data-rmds-addon-variant]') !== null || card.dataset.rmdsAddonLoaded === 'true';
        const addOnVariant = findAddOnVariant(card, size);
        const legacyVariant = findEmbeddedVariant(card, size) || findMasterVariant(masterProducts[card.dataset.master], size, card.dataset.rmdsFrame);
        const variant = hasAddOnProduct ? addOnVariant : legacyVariant;
        card.disabled = !variant || variant.available === false;
        if (variant) {
          const total = hasAddOnProduct
            ? Number(selectedOption.dataset.price) + Number(variant.price)
            : Number(variant.price);
          priceNode.textContent = `${formatMoney(total)} total`;
        } else {
          priceNode.textContent = 'Not available in this size';
        }
        if (card === selectedCard && card.disabled) selectCard(cards[0]);
      });
    }

    function selectCard(card) {
      if (!card || card.disabled) return;
      cards.forEach((item) => {
        const active = item === card;
        item.classList.toggle('selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      selectedCard = card;
      error.hidden = true;
      if (fallbackAddButton) fallbackAddButton.disabled = card.disabled;
      if (card.dataset.master === 'unframed') {
        setNativeVariant();
        updateDisplayedPrice(sizeSelect.options[sizeSelect.selectedIndex].dataset.price);
      } else {
        const choice = selectedFrameChoice();
        if (choice && choice.variant && choice.totalPrice != null) updateDisplayedPrice(choice.totalPrice);
      }
    }

    cards.forEach((card) => card.addEventListener('click', () => selectCard(card)));
    extraOptionSelects.forEach((select) => select.addEventListener('change', () => {
      const previousSize = selectedSize();
      selectMatchingSize(previousSize);
      buildCustomSizePicker();
      restoreSizeLabels();
      updateCards();
      selectCard(selectedCard.disabled ? cards[0] : selectedCard);
      switchToSelectedArtworkImage();
    }));
    sizeSelect.addEventListener('change', () => {
      restoreSizeLabels();
      syncCustomSizePicker();
      updateCards();
      selectCard(selectedCard.disabled ? cards[0] : selectedCard);
    });

    form.addEventListener('submit', async (event) => {
      if (selectedCard.dataset.master === 'unframed') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const choice = selectedFrameChoice();
      if (!choice || !choice.variant || choice.variant.available === false) {
        error.textContent = 'This frame is not available in the selected size.';
        error.hidden = false;
        return;
      }

      const button = form.querySelector('[data-add-to-cart]');
      const quantity = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
      const selectedArtworkOption = sizeSelect.options[sizeSelect.selectedIndex];
      const artworkVariantId = Number(sizeSelect.value);
      if (button) button.setAttribute('aria-disabled', 'true');
      if (fallbackAddButton) fallbackAddButton.disabled = true;

      try {
        let items;

        if (choice.mode === 'addon') {
          // Flexible framing: the real artwork variant remains the parent line and the
          // frame-only product is nested underneath it. Shopify therefore charges
          // artwork price + frame price, whatever the artwork happens to cost.
          const parentProperties = Object.assign({}, existingLineItemProperties(), {
            Frame: selectedCard.dataset.rmdsFrame,
            '_RMDS framed': 'true',
            '_Frame add-on variant ID': String(choice.variant.id)
          });

          const childProperties = {
            '_RMDS frame add-on': 'true',
            '_Frame label': selectedCard.dataset.rmdsFrame,
            '_Artwork URL': root.dataset.productUrl,
            '_Artwork handle': root.dataset.productHandle,
            '_Artwork product ID': root.dataset.productId,
            '_Artwork variant ID': String(artworkVariantId),
            '_Artwork image': selectedArtworkOption.dataset.image || root.dataset.productImage
          };

          items = [
            {
              id: artworkVariantId,
              quantity,
              properties: parentProperties
            },
            {
              id: choice.variant.id,
              quantity,
              parent_id: artworkVariantId,
              properties: childProperties
            }
          ];
        } else {
          // Backwards-compatible fallback: if a frame add-on product isn't available
          // on the Online Store yet, keep the existing one-line framed-product flow.
          items = [{
            id: choice.variant.id,
            quantity,
            properties: Object.assign({
              Artwork: root.dataset.productTitle,
              Frame: selectedCard.dataset.rmdsFrame,
              '_Artwork URL': root.dataset.productUrl,
              '_Artwork handle': root.dataset.productHandle,
              '_Artwork product ID': root.dataset.productId,
              '_Artwork variant ID': String(artworkVariantId),
              '_Artwork image': selectedArtworkOption.dataset.image || root.dataset.productImage
            }, artworkProperties(), existingLineItemProperties())
          }];
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'The framed print could not be added.');
        window.location.assign('/cart');
      } catch (e) {
        error.textContent = e.message;
        error.hidden = false;
        if (button) button.removeAttribute('aria-disabled');
        if (fallbackAddButton) fallbackAddButton.disabled = false;
      }
    }, true);

    selectMatchingSize(normalizedSize(sizeSelect.options[sizeSelect.selectedIndex].dataset.title));
    updateCards();
    buildCustomSizePicker();
    restoreSizeLabels();
    // Restore once more after third-party product option scripts initialise.
    window.setTimeout(restoreSizeLabels, 500);
    window.setTimeout(restoreSizeLabels, 1500);
    syncFallbackAddButton();
    window.setTimeout(syncFallbackAddButton, 500);
    window.setTimeout(syncFallbackAddButton, 1500);
    selectCard(selectedCard);

    // Load frame-only add-on products that Liquid could not embed. The previous
    // version defined this loader but never actually called it, which meant the
    // selector always stayed on the legacy fixed framed prices in theme preview.
    // Re-price the cards as soon as each lookup settles so any available add-on
    // immediately switches to artwork price + frame price.
    const addOnCards = cards.filter((card) => card.dataset.master !== 'unframed');
    Promise.allSettled(addOnCards.map((card) => loadAddOnProduct(card))).then(() => {
      updateCards();
      if (selectedCard && !selectedCard.disabled) selectCard(selectedCard);
    });

    // Globo may load after the theme. Hide only its former frame widget on
    // pages using this replacement selector; leave the app untouched elsewhere.
    function hideLegacyFrameWidget() {
      const blocks = root.closest('.product-blocks');
      if (!blocks) return;
      Array.from(blocks.children).forEach((child) => {
        if (child === root || child.contains(root)) return;
        const text = String(child.textContent || '').toLowerCase();
        if (text.includes('want your print ready to hang') || text.includes('select a frame below')) {
          child.hidden = true;
        }
      });
    }
    hideLegacyFrameWidget();
    const legacyObserver = new MutationObserver(hideLegacyFrameWidget);
    legacyObserver.observe(root.closest('.product-blocks') || root, { childList: true, subtree: true });
    window.setTimeout(() => legacyObserver.disconnect(), 5000);
  }

  selectors.forEach(init);
})();
